import module from 'recursoshumanos/module.js'
import template from './template.html'

export class RecursoshumanosLotesCargarConfirmarComponent {
  periodo
  mes
  idEmpresa = null
  registroPatronal = null
  periodicidad = null
  onClose = null
  valido = null
  erroneos = null

  constructor (RecursoshumanosPagosSuaService) {
    this.RecursoshumanosPagosSuaService = RecursoshumanosPagosSuaService
  }

  $onInit () {
    this.valido = !(this.erroneos)
    this.periodicidad = (+this.periodicidad === 1) ? 2 : 1
  }

  omitir () {
    this.valido = true
  }

  guardar () {
    if (this.actualizando) return

    this.actualizando = true

    this.RecursoshumanosPagosSuaService.post(this.idEmpresa, this.registroPatronal, this.periodicidad, this.resultados, this.periodo, this.mes)
      .then(({data}) => {
        if (data.capturados !== 0 && data.encontrados !== 0) {
          this.finalizoMessage = `Se actualizarón ${data.encontrados} pagos y se insertaron ${data.capturados} nuevos pagos`
        }else if (data.encontrados !== 0) {
          this.finalizoMessage = `Se actualizarón ${data.encontrados} pagos`
        } else {
          this.finalizoMessage = `Se insertaron ${data.capturados} nuevos pagos`
        }
        this.completado = true
      })
      .catch((error) => (this.error = error.data || error))
      .finally(() => (this.actualizando = false))
  }

  cerrar () {
    if (this.completado) {
      this.onClose({$event: {detail: true}})
    } else {
      this.onClose({$event: {detail: false}})
    }
  }
}

module.component('recursoshumanosPagosSuaConfirmar', {
  controller: RecursoshumanosLotesCargarConfirmarComponent,
  template,
  bindings: {
    erroneos: '<',
    resultados: '<',
    onClose: '&',
    idEmpresa: '<',
    registroPatronal: '<',
    periodicidad: '<',
    periodo: '<',
    mes: '<',
  },
})



// WEBPACK FOOTER //
// ./src/recursoshumanos/components/pagossua/confirmar/component.js